export default "__VITE_ASSET__4bf931f9__"